import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  CMS_PAGE_ROUTE_CONTEXT,
  CmsPageRouteContext,
  SrmCreateComponent,
  SrmDetailsComponent,
  SrmNavigationService,
  SrmOverviewComponent,
} from '@libs/services/components';

@Component({
  selector: 'ui-srm',
  templateUrl: './srm.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SrmNavigationService],
  imports: [SrmOverviewComponent, SrmCreateComponent, SrmDetailsComponent],
})
export class SrmComponent {
  private readonly routeContext: CmsPageRouteContext = inject(CMS_PAGE_ROUTE_CONTEXT);

  public readonly urlSuffix: string | undefined = this.routeContext.urlSuffix;
}
